import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mobile-app-page__blur" }, null, -1)
const _hoisted_2 = { class: "mobile-app-page__content" }
const _hoisted_3 = { class: "mobile-app-page__item" }
const _hoisted_4 = { class: "mobile-app-page__item" }
const _hoisted_5 = { class: "mobile-app-page__description" }
const _hoisted_6 = { class: "mobile-app-page__item mobile-app-page__item--plarform" }

import { AppUpdate } from '@capawesome/capacitor-app-update';
import { isAndroid, isIOS, deviceDetect } from 'mobile-device-detect';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import GridLines from '@exchange/assets/grid-lines.svg';
import AppHeader from '@exchange/layouts/app-header/AppHeader.vue';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import { capIsNativePlatform, capAppLauncher } from '@exchange/libs/utils/capacitor/src';
import { logger } from '@exchange/libs/utils/simple-logger/src';

type PlatformItem = {
  name: string;
  link: string;
};

const __default__ = {
  name: 'MobileAppPage',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();
const { t } = useI18n({ useScope: 'global' });
const { isXS } = useMQBreakpoints();
const isNative = capIsNativePlatform();

const iOSLink = 'https://apps.apple.com/at/app/one-trading/id1545308731';
const androidLink = 'https://play.google.com/store/apps/details?id=com.bitpanda.exchange';

const platforms: Array<PlatformItem> = [
  {
    name: 'apple',
    link: iOSLink,
  },
  {
    name: 'google',
    link: androidLink,
  },
];

const goBack = () => {
  router.go(-1);
};

const openAppStore = async () => {
  const countryToUseForIOSLookup = 'at'; // https://github.com/robingenz/capacitor-app-update/issues/12

  try {
    await AppUpdate.openAppStore({
      country: countryToUseForIOSLookup,
    });
  } catch (error) {
    logger.error('Failed to open app store', error);
  }
};
const openBrowser = (link: string) => {
  window.location.href = link;
};
const doRedirectToStore = () => {
  if (isNative) {
    logger.log('Openning native store');
    openAppStore();
    return;
  }

  if (isAndroid) {
    logger.log('Openning android link');
    openBrowser(androidLink);
  } else if (isIOS) {
    logger.log('Openning ios link');
    openBrowser(iOSLink);
  } else {
    logger.log('Detected device', deviceDetect());
  }
};

const onLogoClicked = (item: PlatformItem) => {
  if (isNative) {
    logger.log(`${item.name} clicked => openning native store`);
    capAppLauncher.openUrl({ url: item.link });
    return;
  }

  logger.log(`${item.name} clicked => openning browser`);
  openBrowser(iOSLink);
};

doRedirectToStore();

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_logo = _resolveComponent("x-logo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isXS))
      ? (_openBlock(), _createBlock(_component_x_button, {
          key: 0,
          class: "mobile-app-page__header mobile-app-page__header--mobile",
          variant: "clear",
          onClick: goBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ot_icon, { name: "arrow-left" })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(AppHeader, {
          key: 1,
          class: "mobile-app-page__header"
        })),
    _createElementVNode("div", {
      class: _normalizeClass(['mobile-app-page', { 'mobile-app-page--mobile': _unref(isXS) }])
    }, [
      _createVNode(_unref(GridLines), { class: "mobile-app-page__grid-lines" }),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", null, _toDisplayString(_unref(t)('modules.profile.getApp.title')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('modules.profile.getApp.description')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(platforms, (item) => {
            return _createVNode(_component_x_logo, {
              key: item.name,
              name: item.name,
              class: "mobile-app-page__platform-logo",
              type: "badges",
              onClicked: ($event: any) => (onLogoClicked(item))
            }, null, 8, ["name", "onClicked"])
          }), 64))
        ])
      ])
    ], 2)
  ], 64))
}
}

})